import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ items, testid = "faq" }) {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <div data-testid={testid}>
      {items.map((item, i) => (
        <div key={i} className="border-b border-white/10" data-testid={`${testid}-item-${i}`}>
          <button
            onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
            className="w-full flex items-center justify-between gap-6 py-6 text-left"
            data-testid={`${testid}-question-${i}`}
          >
            <span className="font-serif-display font-light text-lg md:text-xl text-[#F5F5F0]">{item.q}</span>
            <span className="text-[#C4A484] shrink-0">
              {openIndex === i ? <Minus size={18} /> : <Plus size={18} />}
            </span>
          </button>
          <AnimatePresence initial={false}>
            {openIndex === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                className="overflow-hidden"
              >
                <p className="pb-6 text-sm md:text-base font-light text-zinc-400 leading-relaxed max-w-3xl" data-testid={`${testid}-answer-${i}`}>
                  {item.a}
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
